export enum OrderStatus {
    None = 0,
    NotSubmittedByUser = 32,
    SubmittedByUser = 64,
    InApprovalProcess = 128,
    ApprovedScheduled = 256,
    ApprovedImmediate = 512,
    ReadyForPayout = 1024,
    PaidOut = 2048,
    Completed = 8,
    Cancelled = 16,
    RequiresResubmissionOfInfo = 4096,
    Failed = 8192,
}

export namespace OrderStatus {
    export function toString(orderStatus: OrderStatus): string {
        switch (orderStatus) {
            case OrderStatus.None:
                return '';
            case OrderStatus.NotSubmittedByUser:
                return 'Not submitted by user';
            case OrderStatus.SubmittedByUser:
                return 'Submitted by user';
            case OrderStatus.InApprovalProcess:
                return 'In approval process';
            case OrderStatus.ApprovedScheduled:
                return 'Approved scheduled';
            case OrderStatus.ApprovedImmediate:
                return 'Approved immediate';
            case OrderStatus.ReadyForPayout:
                return 'Ready for payout';
            case OrderStatus.PaidOut:
                return 'Paid out';
            case OrderStatus.Completed:
                return 'Completed';
            case OrderStatus.Cancelled:
                return 'Cancelled';
            case OrderStatus.RequiresResubmissionOfInfo:
                return 'Requires resubmission of info';
            case OrderStatus.Failed:
                return 'Failed';
            default:
                return 'Status unknown';
        }
    }

    export function parse(orderStatusStr: string): OrderStatus {
        return OrderStatus[orderStatusStr];
    }
}

export default OrderStatus;
